(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
(() => {
  const openPopup = (popup) => {
    popup.hidden = false;
    requestAnimationFrame(() => popup.classList.add('is-open'));
  };

  const closePopup = (popup) => {
    popup.classList.remove('is-open');
    window.setTimeout(() => {
      popup.hidden = true;
    }, 280);
  };

  const sessionKey = 'kleinianNewsletterShown';
  const shownAtKey = 'kleinianNewsletterShownAt';
  const joinedKey = 'kleinianNewsletterJoined';
  const quietPeriod = 24 * 60 * 60 * 1000;

  // sessionStorage is per tab; the session cookie covers every tab and clears when the browser closes.
  // The localStorage timestamp is a backup for browsers that drop session cookies or storage.
  const wasShownThisSession = () => {
    if (document.cookie.split('; ').includes(`${sessionKey}=1`)) return true;
    try {
      if (window.localStorage.getItem(joinedKey) === 'true') return true;
      if (Date.now() - Number(window.localStorage.getItem(shownAtKey) || 0) < quietPeriod) return true;
      return window.sessionStorage.getItem(sessionKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const markShownThisSession = () => {
    document.cookie = `${sessionKey}=1; path=/; SameSite=Lax`;
    try {
      window.localStorage.setItem(shownAtKey, String(Date.now()));
      window.sessionStorage.setItem(sessionKey, 'true');
    } catch (error) {
      return;
    }
  };

  const markJoined = () => {
    try {
      window.localStorage.setItem(joinedKey, 'true');
    } catch (error) {
      return;
    }
  };

  const showSuccess = (popup, form) => {
    const template = popup.querySelector('template[data-newsletter-success]');
    if (template) form.replaceChildren(template.content.cloneNode(true));
    popup.classList.add('is-success');
    markJoined();
    form.querySelector('.kleinian-newsletter__success')?.focus({ preventScroll: true });
  };

  const showError = (form, errors) => {
    form.querySelector('.errors')?.remove();
    form.querySelector('.kleinian-newsletter__field')?.before(errors);
  };

  const genericError = () => {
    const errors = document.createElement('div');
    errors.className = 'errors';
    errors.innerHTML = '<ul><li>Something went wrong. Please try again.</li></ul>';
    return errors;
  };

  const nativeSubmit = (form) => HTMLFormElement.prototype.submit.call(form);

  // Shopify's hCaptcha keeps a reference to form.submit when it binds (on first focus) and calls it once the
  // token is attached, so this replacement has to be in place before the visitor touches the form.
  const bindAjaxSubmit = (popup) => {
    const form = popup.querySelector('form.kleinian-newsletter__form');
    if (!form || popup.querySelector('.kleinian-newsletter__success')) return;
    const button = form.querySelector('[type="submit"]');
    let pending = false;

    form.submit = async () => {
      if (pending) return;
      pending = true;
      button?.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const succeeded = response.ok && (response.url.includes('customer_posted=true') || doc.querySelector('.kleinian-newsletter__success'));

        if (succeeded) {
          showSuccess(popup, form);
          return;
        }

        // Shopify sends visitors it wants to verify to a challenge page, which returns them with the signup completed.
        if (response.url.includes('/challenge')) {
          window.location.assign(response.url);
          return;
        }

        const errors = doc.querySelector(`#${CSS.escape(form.id)} .errors`);
        showError(form, errors ? document.importNode(errors, true) : genericError());
      } catch (error) {
        nativeSubmit(form);
      } finally {
        pending = false;
        button?.removeAttribute('aria-busy');
      }
    };
  };

  const initPopup = (popup) => {
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    popup.querySelectorAll('[data-newsletter-close]').forEach((button) => {
      button.addEventListener('click', () => closePopup(popup));
    });

    bindAjaxSubmit(popup);

    // In the theme editor the popup only opens when its section is selected.
    if (popup.dataset.designMode === 'true') return;

    const email = popup.querySelector('input[type="email"]');
    const delay = Number(popup.dataset.delay || 650);

    if (popup.querySelector('.kleinian-newsletter__success')) {
      popup.classList.add('is-success');
      markShownThisSession();
      markJoined();
      openPopup(popup);
      return;
    }

    const forceOpen = new URLSearchParams(window.location.search).has('research_popup');
    if (!forceOpen && wasShownThisSession()) return;
    markShownThisSession();

    window.setTimeout(() => {
      openPopup(popup);
      window.setTimeout(() => email?.focus({ preventScroll: true }), 300);
    }, delay);
  };

  document.querySelectorAll('[data-kleinian-newsletter]').forEach(initPopup);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-kleinian-newsletter].is-open').forEach(closePopup);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initPopup(event.target.querySelector('[data-kleinian-newsletter]'));
  });

  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target.querySelector('[data-kleinian-newsletter]');
    if (popup) openPopup(popup);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const popup = event.target.querySelector('[data-kleinian-newsletter]');
    if (popup) closePopup(popup);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
